import {LngKeys} from "@app/shared/enums";
import {FormsModule} from '@angular/forms';
import {LngRoutePipe} from "@app/shared/pipes";
import {Language} from "@app/shared/interfaces";
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzModalService} from "ng-zorro-antd/modal";
import {NzSelectModule} from 'ng-zorro-antd/select';
import {TranslateModule} from "@ngx-translate/core";
import {copyToClipboard} from "@app/shared/helpers";
import {NzDividerModule} from "ng-zorro-antd/divider";
import {NzPopoverModule} from "ng-zorro-antd/popover";
import {NzTooltipModule} from "ng-zorro-antd/tooltip";
import {SfTrimDirective} from "@app/shared/directives";
import {setItemStore} from "@app/shared/helpers/storage";
import {redirectToTranslatedPath} from "@app/shared/helpers";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {NgOptimizedImage, NgTemplateOutlet} from '@angular/common';
import {AnalyticsService, AuthService} from "@app/shared/services";
import {LANGUAGES_OBJ} from "@app/shared/constants/languages_data";
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {AppStateService} from "@app/shared/services/app-state.service";
import {projectMessages} from "@app/shared/constants/project-messages";
import {DropdownComponent} from "@app/shared/ui-kits/dropdown/dropdown.component";
import {NzDrawerModule, NzDrawerRef, NzDrawerService} from 'ng-zorro-antd/drawer';
import {NzDropdownDirective, NzDropdownMenuComponent} from "ng-zorro-antd/dropdown";
import {NzMenuDirective, NzMenuDividerDirective, NzMenuItemComponent} from "ng-zorro-antd/menu";
import {CouponBannerComponent} from "@app/shared/ui-kits/coupon-banner/coupon-banner.component";
import {ProjectSocialIconsComponent} from "@app/shared/ui-kits/project-social-icons/project-social-icons.component";
import {
  afterNextRender,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  input,
  Input,
  OnInit,
  output,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild
} from "@angular/core";

@Component({
  selector: 'sf-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    FormsModule,
    NzIconModule,
    LngRoutePipe,
    NzSelectModule,
    NzDrawerModule,
    NzDividerModule,
    NzPopoverModule,
    NzMenuDirective,
    NzTooltipModule,
    TranslateModule,
    SfTrimDirective,
    NgOptimizedImage,
    RouterLinkActive,
    NgTemplateOutlet,
    DropdownComponent,
    NzDropdownDirective,
    NzMenuItemComponent,
    NzMenuDividerDirective,
    NzDropdownMenuComponent,
    ProjectSocialIconsComponent,
  ]
})
export class HeaderComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly renderer = inject(Renderer2);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly authService = inject(AuthService);
  private readonly nzModalService = inject(NzModalService);
  private readonly nzDrawerService = inject(NzDrawerService);
  protected readonly appStateService = inject(AppStateService);
  protected readonly analyticsService = inject(AnalyticsService);
  protected readonly changeDetectorRef = inject(ChangeDetectorRef);

  protected readonly projectMessages = projectMessages;

  public wrapperClassName = input('');
  @Input() public tmTitle = 'Some Title';
  @Output() public tmTitleChange = new EventEmitter<string>();

  @Input() public hasGetStaredBtn = true;
  @Input() public hasNavbar = true;
  protected emailSentState = false;
  protected userEmailCopiedState = false;

  public onTitleEditMode = false
  @ViewChild('TmTitleElRef') private readonly tmTitleElRef: ElementRef<HTMLInputElement> | null = null
  @Input() public hasTmTitle = false;
  @Input() public hasBuilderButtons = false;
  protected bannersState = false;

  @Output() public readonly download$ = new EventEmitter<void>();
  @Output() public readonly preview$ = new EventEmitter<void>();
  @Output() public readonly getTemplateUrl$ = new EventEmitter<void>();
  @Output() public readonly downloadUsImage$ = new EventEmitter<void>();
  public readonly downloadAsTxt$ = output();

  protected navigator: Navigator | null = null;

  @Input() public getTemplateUrlLoaderState = false;

  protected isReady = false;

  @ViewChild('HeaderSidebarRed') private headerSidebarRed!: TemplateRef<{
    $implicit: unknown;
    drawerRef: NzDrawerRef;
  }>;
  @ViewChild('SidebarTitleRef') private sidebarTitleRef!: TemplateRef<ElementRef>;
  private drawerRef: NzDrawerRef | null = null;


  constructor() {
    afterNextRender(() => {
      setTimeout(() => {
        this.navigator = window.navigator;
        this.isReady = true;
        this.changeDetectorRef.detectChanges();
      }, 100);


      this.changeDetectorRef.detectChanges();
      setTimeout(() => this.changeDetectorRef.detectChanges());
    });
  }

  ngOnInit() {
    setTimeout(() => this.bannersState = true, 5000);

    this.appStateService.closeCouponBanner$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.onCloseCouponBanner());
  }

  protected openSidebarMenu() {
    this.drawerRef = this.nzDrawerService.create({
      nzClosable: false,
      nzContent: this.headerSidebarRed,
      nzTitle: this.sidebarTitleRef
    });

    this.drawerRef.afterClose
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((closed: boolean) => {
        if (!closed && closed !== undefined) {
          window.scrollTo(0, 0);
        }
      });
  }

  protected closeSidebarMenu(closed = false): void {
    this.drawerRef?.close(closed);
  }

  protected logOut() {
    this.closeSidebarMenu();

    this.authService.signOut().subscribe();
    this.router.navigate([this.appStateService.getLngRout('home')]);
  }

  protected resentEmail() {
    this.emailSentState = true;
    this.authService.resendEmail()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    setTimeout(() => this.emailSentState = false, 10 * 1000);
  }

  protected onTmTitleEdit() {
    this.onTitleEditMode = true;
    setTimeout(() => this.tmTitleElRef?.nativeElement.focus());
  }

  protected onBlurTmTitle() {
    this.onTitleEditMode = false;
    this.tmTitleChange.emit(this.tmTitle);
  }

  protected onDownload() {
    this.download$.emit();
  }

  protected changeLanguage(event: Language) {
    this.appStateService.setLng(event.key);
    this.appStateService.setHtmlLangAttribute(event.key, this.renderer);
    this.appStateService.addMetaTags(LANGUAGES_OBJ[event.key as LngKeys].seo);

    redirectToTranslatedPath(this.router, event.key, this.appStateService);
  }

  protected onPreviewTemplate() {
    this.preview$.emit();
  }

  protected getTemplateUrl() {
    this.getTemplateUrl$.emit();
  }

  protected downloadAsImage() {
    this.downloadUsImage$.emit();
  }

  protected downloadAsTxt() {
    this.downloadAsTxt$.emit();
  }

  protected onCopyUserEmail(event?: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();

    if (!this.userEmailCopiedState && this.appStateService.user?.email) {
      this.userEmailCopiedState = true;
      copyToClipboard(this.appStateService.user.email);
      setTimeout(() => this.userEmailCopiedState = false, 2000);
    }
  }

  protected onCloseCouponBanner() {
    this.appStateService.couponBannerClosed = true;
    setItemStore('couponBannerClosed', true);
    this.onReferFriend();
  }

  protected onReferFriend() {
    this.nzModalService.create({
      nzContent: CouponBannerComponent,
      nzFooter: null,
      nzClosable: false
    });
  }

  protected onClickedLinkedin() {
    this.analyticsService.track("builder_linkedin_follow", this.appStateService.user!);
  }

}
